import { render } from "./McpAppRenderer.vue?vue&type=template&id=ff74abd0&scoped=true"
import script from "./McpAppRenderer.vue?vue&type=script&lang=js"
export * from "./McpAppRenderer.vue?vue&type=script&lang=js"

import "./McpAppRenderer.vue?vue&type=style&index=0&id=ff74abd0&scoped=true&lang=css"
import "./McpAppRenderer.vue?vue&type=style&index=1&id=ff74abd0&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff74abd0"]])

export default __exports__